import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { UserService } from '../service/UserService';


export default function RegistrationDialog(props) {
  // const [open, setOpen] = React.useState(true);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  // handle type
  const [usertype, setType] = React.useState(0);

  const handleChange = (event) => {
    setType(event.target.value);
    // console.log(event.target.value);
  };


  // use ref to get input
  const [username, password, email, phone] = [React.useRef(), React.useRef(), React.useRef(), React.useRef()]


  // register function
  function register() {
    // TODO: check formation
    // TODO: write to db by service
    // const userInfo = {
    //   "name": username.current.value,
    //   "password": password.current.value,
    //   "type": usertype,
    //   "email": email.current.value,
    //   "phone": phone.current.value
    // }

    // UserService.registerUser(userInfo).then(response => {
    //   console.log(response.data);
    // }).catch(error => {
    //   console.log(error);
    // })
    UserService.registerUser(username.current.value, password.current.value, usertype, email.current.value, phone.current.value).then(response => {
      console.log(response.data);
    }).catch(error => {
      console.log(error);
    })

    // test to print out written values:
    console.log(username.current.value, password.current.value, email.current.value, phone.current.value, usertype)
    console.log(typeof username.current.value)
    console.log(typeof password.current.value)
    console.log(typeof email.current.value)
    console.log(typeof phone.current.value)
    console.log(typeof usertype)
    props.handleClose();
  }

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open form dialog
      </Button> */}
      <Dialog open={props.open} onClose={props.handleClose}>
        <DialogTitle>Registration</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Register as a Leptoner!
          </DialogContentText>

          <TextField id="standard-basic" required label="Username"
            variant="standard" fullWidth autoFocus inputRef={username} />
          <TextField id="standard-basic" required label="Password"
            variant="standard" type={"password"} fullWidth
            inputRef={password} />

          <TextField id="standard-basic" required label="Email"
            variant="standard" type={"email"} fullWidth inputRef={email} />
          <TextField id="standard-basic" required label="Phone"
            variant="standard" fullWidth inputRef={phone} />

          <InputLabel id="demo-simple-select-label">User Type</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={usertype}
            label="Type"
            onChange={handleChange}
          >
            <MenuItem value={1}>Composer</MenuItem>
            <MenuItem value={2}>Audience</MenuItem>
          </Select>


        </DialogContent>
        <DialogActions>
          <Button onClick={register} variant={'contained'}>Sumbit</Button>
          <Button onClick={props.handleClose} variant={'contained'}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}